import { combineReducers } from 'redux';
import * as actions from '../actions/ActionTypes';

const initialState = {
  startTime: null,
  endTime: null,
  lastAction: null,
};

const startTime = (state = initialState.startTime, action) => {
  switch (action.type) {
    case actions.RECORDING_PROBE_STARTED:
      return action.startedAt;
    default:
      return state;
  }
};

const endTime = (state = initialState.endTime, action) => {
  switch (action.type) {
    case actions.RECORDING_PROBE_FINISHED:
      return action.finishedAt;
    default:
      return state;
  }
};

const lastAction = (state = initialState.lastAction, action) => {
  switch (action.type) {
    case actions.RECORDING_PROBE_FINISHED:
      return state;
    default:
      return action.type;
  }
};

export default combineReducers({
  startTime,
  endTime,
  lastAction,
});
